module.exports = __webpack_public_path__ + "static/media/amex_logo.fb44ba49.png";